// AUTO-GENERATED GraphQL Builder for HeldShareRebalanceLine
import * as Builders from '../';
export class HeldShareRebalanceLineBuilder {
  private s:string[]=[]; private r:string[]=[]; private v=new Set<string>(); depth=0;
  private add(f:string){ if(!this.s.includes(f)) this.s.push(f); return this; }
  getSelections(){ return [...this.s]; }
  toSelectionSet(){ const a=[...this.s,...this.r]; if(!a.length)return`{ id }`; return`{\n  ${a.join("\n  ")}\n}`;}
  vendorId(){ return this.add('vendorId'); }
  vendorName(){ return this.add('vendorName'); }
  held(){ return this.add('held'); }
  target(){ return this.add('target'); }
  reversed(){ return this.add('reversed'); }
  added(){ return this.add('added'); }
  refs(){ return this.add('refs'); }
  note(){ return this.add('note'); }
}
